import { Source, Layer } from 'react-map-gl';
import { COLOR } from '../styles';
import { sourceProps } from './source-utils';

export function ZonasParceladasLayer({ url }: { url: string }) {
  return (
    <Source id="zonas-parceladas" {...sourceProps(url)}>
      <Layer
        id="zonas-parceladas-fill"
        type="fill"
        paint={{ 'fill-color': COLOR.amber, 'fill-opacity': 0.07 }}
      />
      <Layer
        id="zonas-parceladas-casing"
        type="line"
        paint={{ 'line-color': 'rgba(0,0,0,0.55)', 'line-width': 5, 'line-opacity': 0.5 }}
      />
      <Layer
        id="zonas-parceladas-outline"
        type="line"
        paint={{ 'line-color': COLOR.amber, 'line-width': 2, 'line-opacity': 0.90 }}
      />
    </Source>
  );
}
